import apiClient from "@/services/apiClient";

export async function getSearchSuggestions(query) {
  const { data } = await apiClient.get("/public/search/suggest", {
    params: { q: query },
  });
  return data;
}

export async function getTrendingSearches() {
  const { data } = await apiClient.get("/public/search/trending");
  return data;
}

export async function getLearnerFavorites() {
  const { data } = await apiClient.get("/public/search/favorites");
  return data;
}

export function logSearch(query) {
  // Fire-and-forget -- feeds trending() aggregates, never blocks navigation on the result.
  apiClient.post("/public/search/log", { query }).catch(() => {});
}
